import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks, accessSummary, accessDetail } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-129" data-mp="34dbwc9fk00k9">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-130" data-mp="34ckc1urepp9a">
        <SectionTag icon="📦" data-id="element-131" data-mp="30ca62i3m6yuf">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-132" data-mp="2vkid60wzkh14">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-133" data-mp="2qlxfo994cbgd">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-2xl px-6 sm:px-8" data-id="element-134" data-mp="2gly3m2dhq2yr">
        <ScrollHintTable minWidth="360px" data-id="element-135" data-mp="2clwdmqh4axzb">
          <table className="w-full text-left text-sm" data-id="element-136" data-mp="2cmxqn0hp1ujo">
            <thead data-id="element-137" data-mp="35oyi8448d175">
              <tr className="border-b border-gris-claro bg-bg-secondary text-xs uppercase tracking-wide text-gris-muted" data-id="element-138" data-mp="35of30v5ysqwt">
                <th className="px-5 py-3 font-semibold" data-id="element-139" data-mp="3agzrria0kdth">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-140" data-mp="2vraamdlizz7k">Páginas</th>
              </tr>
            </thead>
            <tbody className="bg-white" data-id="element-141" data-mp="30ou3aiiz0ej1">
              {accessRows.map((row, i) => <tr key={row.format} className={i !== accessRows.length - 1 ? 'border-b border-gris-claro' : ''} data-id="element-142" data-mp="3oeoekvnn5v16" data-mpi={i}>
                  <td className="px-5 py-4 text-marino" data-id="element-143" data-mp="3td7yyrml6yrf">{row.format}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-naranja" data-id="element-144" data-mp="3ferruzktb68r">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <p className="mt-6 text-center text-sm leading-relaxed text-gris-texto" data-id="element-145" data-mp="23ytfalqfe22s">{accessSummary}</p>
        <p className="mt-3 text-center text-xs leading-relaxed text-gris-muted" data-id="element-146" data-mp="281fzc0guuipf">{accessDetail}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-147" data-mp="eiqtp56nt7in">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-gris-texto" data-id="element-148" data-mp="9k5rj07ukdrk">
              <CheckIcon size={16} className="text-verde" data-id="element-149" data-mp="4rmdk258zgm8" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}